import { MemberManager } from '../../../managers/member.manager';
import { MemberEventsService } from '../../../services/member.events.service';
import { Router } from '@angular/router';
import { TagArray } from '../../../models/domain/tag';
import { TagsComponent } from '../../../shared/components/tags/tags.component';
import { Member } from '../../../models/domain/member';
import { Component, Input, ViewChild, ViewEncapsulation, Output, EventEmitter, HostListener, ElementRef } from '@angular/core';

import { MemberDashboard } from '../../../models/ss-api/responses/member.dashboard.response';
import { MemberTagsEditRequest } from '../../../models/ss-api/requests/tag.edit.request';

@Component({
    selector: 'profile-overview',
    templateUrl: './profile.overview.component.html',
    styleUrls: ['./profile.overview.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class ProfileOverviewComponent {
    // viewchilds
    @ViewChild(TagsComponent)
    private Tags: TagsComponent;

    // inputs
    @Input('DashboardData') DashboardData: MemberDashboard = new MemberDashboard();
    memberType: string;

    // OUTPUTS
    @Output('TagsChanged') TagsChanged = new EventEmitter();
    @Output('MemberChanged') MemberChanged = new EventEmitter();

    @ViewChild("hubspotLink") hubspotLink: ElementRef;

    //Hotkey
    @HostListener('window:keydown.alt.h', ['$event'])
    hubspotHotkey(event: KeyboardEvent) {
        event.preventDefault();
        this.hubspotLink.nativeElement.click();
    }
    
    @HostListener('window:keydown.alt.e', ['$event'])
    editMemberHotkey(event: KeyboardEvent) {
        event.preventDefault();
        this.EditMember();
    }

    constructor(private router: Router, private memberEvents: MemberEventsService) {
    }

    nameForMemberType(type: number) {
        return Member.GetMemberPersonType( type );
    }

    onMemberClick(memberID: number) {
        this.memberEvents.onMemberDashboardChangeRequest.next(memberID);
        this.router.navigate(['/member-profile', memberID]);
    }

    SetTags(tags: TagArray) {
        this.Tags.SetTags(tags);
    }

    EditMember() {
        new MemberManager(this.DashboardData.ID, true)
    }

    TagsChangedCatch( e: MemberTagsEditRequest ) {
        this.TagsChanged.emit( e );
    }


}
